import { render, staticRenderFns } from "./FooterContainer.vue?vue&type=template&id=7ca20bd3&scoped=true&"
import script from "./FooterContainer.vue?vue&type=script&lang=js&"
export * from "./FooterContainer.vue?vue&type=script&lang=js&"
import style0 from "./FooterContainer.vue?vue&type=style&index=0&id=7ca20bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca20bd3",
  null
  
)

export default component.exports